/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = { lastUpdated: null };

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.StartInterviewAction.REQUEST_STARTINTERVIEW:
      return {
        ...state
      };
    case actions.StartInterviewAction.STARTINTERVIEW_RECEIVED:
      return {
        ...state,
        data: action.data,
        lastUpdated: Date.now()
      };

    case actions.StartInterviewAction.REQUEST_UPDATELAYOUT:
      return {
        ...state
      };

    case actions.StartInterviewAction.UPDATELAYOUT_RECIEVED:
      return {
        ...state
      };

    case actions.StartInterviewAction.SEND_PARTICIPANTS_LIST_ONSTART:
      return {
        ...state
      };
    case actions.StartInterviewAction.SEND_PARTICIPANTS_LIST_RECIEVED_ONSTART:
      return {
        ...state
      };

    default:
      return state;
  }
};

export default reducer;
